import { Space, Input, Button, List, Popconfirm } from 'antd';
import React, { useState } from 'react';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import TableWithSorter from '../Common/TableWithSorter';

const FeedbackTemplateTable = ({
  data,
  totalCount,
  archiveItem,
  loading,
  status,
}) => {
  const feedbackData = data.map((item) => {
    let newItem = item;
    newItem.key = item._id;
    return newItem;
  });

  const [searchInput, setSearchInput] = useState('');
  const [state, setState] = useState({
    searchText: '',
    searchedColumn: '',
  });

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setSearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput, 100);
      }
    },
    render: (text) =>
      state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setState({ searchText: '' });
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: '_id',
      key: '_id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Last Modified',
      dataIndex: 'lastModifiedTimeStamp',
      key: 'lastModifiedTimeStamp',
      sorter: (a, b) =>
        new Date(a.lastModifiedTimeStamp).getTime() -
        new Date(b.lastModifiedTimeStamp).getTime(),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Edit',
      dataIndex: 'operation',
      render: (_, record, index) => (
          <span>
          <Popconfirm
              title="Sure to edit?"
              onConfirm={() => {
                archiveItem(record, index);
              }}
          >
            <a>{status === 'active' ? 'Archive': 'Unarchive'}</a>
          </Popconfirm>
        </span>
      )
    }
  ];

  return (
    <TableWithSorter
      tableLayout="auto"
      scroll={{ x: 1000 }}
      // expandable={ {expandedRowRender: record => <FeedbackTemplateQuestionTable data={record}/>} }
      expandable={{
        expandedRowRender: (record) =>
          record.questions.map((item) => {
            return (
              <List.Item>
                <List.Item.Meta
                  title={item.question}
                  description={`Type: ${item.type}`}
                />
              </List.Item>
            );
          }),
      }}
      loading={loading}
      dataSource={feedbackData}
      columns={columns}
      pagination={{
        total: totalCount,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30'],
      }}
    />
  );
};

export default FeedbackTemplateTable;
